module.exports = __webpack_public_path__ + "static/media/buildings_dark.6ca13133.svg";